import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Options } from 'highcharts';
import moment from 'moment/moment';
import _ from 'lodash';
import { Contract, ContractChartService } from '@shared/services/contract-chart.service';
import { GraphComponent } from '../highcharts/graph/graph.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { InvoicingReport, TimedBucket } from '@shared/services/abstract-contract.service';

@Component({
  selector: 'app-contract-graphs',
  templateUrl: './contract-graphs.component.html',
  styleUrl: './contract-graphs.component.scss',
  imports: [GraphComponent, SpinnerComponent],
})
export class ContractGraphsComponent implements OnChanges {
  @Input({ required: true }) public contract: Contract;
  @Input({ required: true }) public invoicingBuckets: InvoicingReport;

  protected requestData: Options;
  protected bandwidthData: Options;
  protected nbSitesData: Options;

  constructor(private contractChartService: ContractChartService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.invoicingBuckets) {
      this.computeGraphs();
    }
  }

  computeGraphs(): void {
    if (this.invoicingBuckets) {
      const dateRange = getDateRange(this.invoicingBuckets);
      this.requestData = this.contractChartService.formaTrafficData(this.contract, this.invoicingBuckets, 'column', {
        xAxis: dateRange,
        ...this.enabledReporting(),
      });
      this.bandwidthData = this.contractChartService.formatBandwidthData(
        this.contract,
        this.invoicingBuckets,
        'column',
        {
          xAxis: dateRange,
          ...this.enabledReporting(),
        },
      );
      this.nbSitesData = this.contractChartService.formatNbSitesData(this.contract, this.invoicingBuckets, 'column', {
        xAxis: dateRange,
        ...this.enabledReporting(),
      });
    } else {
      this.requestData = null;
      this.bandwidthData = null;
      this.nbSitesData = null;
    }
  }

  private enabledReporting = (): Options => {
    return {
      exporting: {
        enabled: true,
      },
    };
  };
}

function getDateRange(buckets: TimedBucket[]): MinMaxDate {
  return {
    min: _(buckets)
      .map((b) => moment(b.date))
      .min()
      .toISOString(),
    max: _(buckets)
      .map((b) => moment(b.date))
      .max()
      .toISOString(),
  };
}

type MinMaxDate = {
  min: string;
  max: string;
};
